export default "__VITE_ASSET__e64a93f8__"